export default "__VITE_PUBLIC_ASSET__246462dd__"